import PropTypes from 'prop-types';
import { CloudinaryPicture } from '@bwoty-web/ui-kit';
import LinkPush from './linkPush';
import { sectionKeys } from '../sections/helper';
import './easyTravel.scss';

const EasyTravel = ({ logo, changeSection }) => {
  return (
    <LinkPush
      onClick={() => {
        changeSection(sectionKeys.locationAndTransfer);
        window.dataLayer.push({
          event: 'HotelPagePush',
          hotelpagepush: 'Click EasyTravel',
        });
      }}
    >
      <CloudinaryPicture
        className="gw-easy-travel__logo"
        alt={logo.alt}
        img={logo.media}
        sizes={[
          {
            height: 30,
          },
        ]}
        lazy
        retina
      />
      <span>{logo.title}</span>
    </LinkPush>
  );
};

EasyTravel.propTypes = {
  logo: PropTypes.shape({
    title: PropTypes.string,
    alt: PropTypes.string,
    media: PropTypes.shape({
    }),
  }).isRequired,
  changeSection: PropTypes.func.isRequired,
};

export default EasyTravel;
